import { render, staticRenderFns } from "./ChannelDetailDashboard.vue?vue&type=template&id=109c4766&"
import script from "./ChannelDetailDashboard.vue?vue&type=script&lang=js&"
export * from "./ChannelDetailDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports